var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoMoov = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.02,
    height: 26.997,
    "data-name": "LOGO - Moov",
    viewBox: "0 0 104.021 26.997",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 8786"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2d2d2d",
    "data-name": "Grupo 8781"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.42 23.545c-.078-.188-.183-.428-.313-.719s-.27-.606-.419-.944-.308-.686-.477-1.043-.328-.7-.478-1.014-.289-.605-.419-.856-.234-.444-.312-.578q-.132 1.392-.213 3.01t-.141 3.273h-1.121q.048-1.062.107-2.141t.135-2.123q.076-1.044.166-2.035t.194-1.875h1q.319.519.685 1.227t.731 1.48q.365.773.7 1.544t.625 1.41q.283-.636.626-1.41t.7-1.544q.367-.772.732-1.48t.684-1.227h1q.4 3.951.6 8.174h-1.121q-.059-1.653-.141-3.273t-.213-3.01c-.078.134-.182.326-.312.578s-.269.536-.419.856-.308.656-.477 1.014-.329.705-.478 1.043-.289.653-.418.944-.234.531-.313.719Z",
    "data-name": "Caminho 4026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.373 21.611a3.875 3.875 0 0 1-.213 1.321 3.022 3.022 0 0 1-.6 1.015 2.637 2.637 0 0 1-.915.654 3.023 3.023 0 0 1-2.307 0 2.621 2.621 0 0 1-.914-.654 3.025 3.025 0 0 1-.6-1.015 4.213 4.213 0 0 1 0-2.636 3 3 0 0 1 .6-1.02 2.588 2.588 0 0 1 .914-.655 3.014 3.014 0 0 1 2.307 0 2.614 2.614 0 0 1 .915.655 3 3 0 0 1 .6 1.02 3.9 3.9 0 0 1 .213 1.315Zm-1.144 0a2.633 2.633 0 0 0-.466-1.645 1.624 1.624 0 0 0-2.536 0 3.138 3.138 0 0 0 0 3.29 1.625 1.625 0 0 0 2.286.25 1.6 1.6 0 0 0 .25-.25 2.63 2.63 0 0 0 .463-1.645Z",
    "data-name": "Caminho 4027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.329 21.611a3.875 3.875 0 0 1-.213 1.321 3.022 3.022 0 0 1-.6 1.015 2.637 2.637 0 0 1-.915.654 3.023 3.023 0 0 1-2.307 0 2.621 2.621 0 0 1-.914-.654 3.024 3.024 0 0 1-.6-1.015 4.212 4.212 0 0 1 0-2.636 3 3 0 0 1 .6-1.02 2.588 2.588 0 0 1 .914-.655 3.014 3.014 0 0 1 2.307 0 2.614 2.614 0 0 1 .915.655 3 3 0 0 1 .6 1.02 3.873 3.873 0 0 1 .213 1.315Zm-1.144 0a2.633 2.633 0 0 0-.466-1.645 1.627 1.627 0 0 0-2.286-.25 1.6 1.6 0 0 0-.25.25 3.138 3.138 0 0 0 0 3.29 1.625 1.625 0 0 0 2.286.25 1.6 1.6 0 0 0 .25-.25 2.632 2.632 0 0 0 .466-1.645Z",
    "data-name": "Caminho 4028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.497 18.544a30.621 30.621 0 0 1-1.079 3.3q-.618 1.579-1.2 2.831h-.991q-.577-1.25-1.2-2.831a31.073 31.073 0 0 1-1.079-3.3h1.18q.141.579.336 1.233t.413 1.3q.217.644.441 1.244c.15.4.291.759.426 1.074q.2-.471.424-1.074t.442-1.244q.219-.642.413-1.3t.336-1.233Z",
    "data-name": "Caminho 4029"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 8784"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 8782"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Caminho 4030"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m26.632 12.77-9.523 9.522-4.482-4.477 5.043-5.043-5.043-5.043 4.479-4.479z",
    "data-name": "Caminho 4027"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4dff",
    d: "m17.102 4.205-3.518 3.519 4.562 4.563.481.48-.481.48-4.562 4.563 3.518 3.519 8.562-8.562-8.562-8.562m0-.96 9.523 9.522-9.523 9.522-4.479-4.479 5.043-5.043-5.043-5.043Z",
    "data-name": "Caminho 4028"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 8783"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Caminho 4031"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "m14 12.77-9.523 9.522L0 17.813l5.043-5.043L0 7.727l4.479-4.479z",
    "data-name": "Caminho 4029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4dff",
    d: "M4.478 4.205.96 7.724l4.562 4.563.481.48-.481.48L.96 17.81l3.518 3.519 8.562-8.562-8.562-8.562m0-.96 9.523 9.522-9.523 9.522L0 17.81l5.043-5.043L0 7.724Z",
    "data-name": "Caminho 4030"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1ed6bb",
    d: "m26.627 12.762 3.38775-3.38775L33.4025 12.762l-3.38775 3.38775z",
    "data-name": "Ret\\xE2ngulo 6135"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2d2d2d",
    "data-name": "Grupo 8222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.01 4.8a4.679 4.679 0 0 0-2.654.821V.915h-2.322v13.033h2.322v-.565A4.7 4.7 0 1 0 44.01 4.8zm0 7.1a2.4 2.4 0 1 1 2.4-2.4 2.4 2.4 0 0 1-2.4 2.398z",
    "data-name": "Caminho 5264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65 5.09v.564a4.7 4.7 0 1 0 0 7.729v.564h2.322V5.09zm-2.678 6.824a2.4 2.4 0 1 1 2.4-2.4 2.4 2.4 0 0 1-2.4 2.4z",
    "data-name": "Caminho 5265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.611 2.19a1.453 1.453 0 0 1 .432-1.053 1.408 1.408 0 0 1 1.044-.441 1.423 1.423 0 0 1 1.044.432 1.444 1.444 0 0 1 .432 1.062 1.4 1.4 0 0 1-.432 1.026 1.478 1.478 0 0 1-2.088 0 1.4 1.4 0 0 1-.432-1.026Zm2.682 11.755h-2.394V5.088h2.394Z",
    "data-name": "Caminho 5266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.377 8.855v5.094h-2.394V5.09h2.322v1.1a2.472 2.472 0 0 1 1.08-.99 3.33 3.33 0 0 1 1.476-.342 2.931 2.931 0 0 1 2.385.981 3.815 3.815 0 0 1 .819 2.529v5.581h-2.394V8.782a1.93 1.93 0 0 0-.405-1.278 1.727 1.727 0 0 0-2.439.036 1.941 1.941 0 0 0-.45 1.315Z",
    "data-name": "Caminho 5267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.038 13.949h-2.394V5.092h2.286v1.08a2.387 2.387 0 0 1 1.08-.972 3.414 3.414 0 0 1 1.512-.36 2.638 2.638 0 0 1 2.629 1.48 3.132 3.132 0 0 1 2.808-1.476 3.059 3.059 0 0 1 3.2 3.366v5.743h-2.322V8.697a1.822 1.822 0 0 0-.387-1.215 1.456 1.456 0 0 0-1.179-.459 1.516 1.516 0 0 0-1.188.5 1.8 1.8 0 0 0-.45 1.242v5.184H80.26V8.693a1.8 1.8 0 0 0-.4-1.215 1.461 1.461 0 0 0-1.17-.459 1.55 1.55 0 0 0-1.206.495 1.789 1.789 0 0 0-.45 1.251Z",
    "data-name": "Caminho 5268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.576 2.19a1.453 1.453 0 0 1 .432-1.053 1.408 1.408 0 0 1 1.044-.441 1.423 1.423 0 0 1 1.044.432 1.444 1.444 0 0 1 .432 1.062 1.4 1.4 0 0 1-.432 1.026 1.478 1.478 0 0 1-2.088 0 1.4 1.4 0 0 1-.432-1.026Zm2.682 11.755h-2.394V5.088h2.394Z",
    "data-name": "Caminho 5269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93 2.78v11.171h2.394v-2.34l.99-1.044 2.34 3.384h2.934l-3.618-5.13 3.546-3.726h-3.132l-3.06 3.294V2.781z",
    "data-name": "Caminho 5270"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoMoov);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoMoov.d85fe7da1fb01acc04c0c624df930160.svg";